import { combineReducers } from 'redux';
import countryListReducer from './countryReducer';
import CustomizerReducer from './customizerReducer';
import {
  ngoAddReducer,
  ngoArrivalReducer,
  ngoByIdReducer,
  ngoDeleteReducer,
  ngoListReducer,
  ngoPreRegisterReducer,
  ngoUpdateIsActiveReducer,
  ngoUpdateReducer,
  oneNgoPreRegisterReducer,
} from './ngoReducer';
import {
  swDetailsReducer,
  swUpdateIsActiveReducer,
  swListReducer,
  swByIdReducer,
  swUpdateReducer,
  swAddReducer,
  swMigrateReducer,
  swMigrateOneReducer,
  swDeleteReducer,
} from './socialWorkerReducer';
import {
  childActiveListReducer,
  childAddReducer,
  childByIdReducer,
  childListReducer,
  childNameCheckReducer,
  childPreRegisterReducer,
  childrenByNgoReducer,
  childSayNameReducer,
  childUpdateReducer,
  childUpdateStatusReducer,
  oneChildPreRegisterReducer,
} from './childrenReducer';
import {
  userLoginReducer,
  myPageReducer,
  userChangePasswordReducer,
  userSearchReducer,
  userChildrenReducer,
  userBuilderStatusReducer,
  userFetchReducer,
  userCheckPointsReducer,
} from './userReducer';
import {
  allNeedsReducer,
  allReportNeedsReducer,
  childNeedsReducer,
  childOneNeedReducer,
  deleteOldNeedsReducer,
  duplicatesReducer,
  exampleNeedsReducer,
  massConfirmReducer,
  needAddReducer,
  needConfirmReducer,
  needStatusUpdateReducer,
  needUpdateReducer,
  prepareConfirmReducer,
  swNeedListReducer,
  unconfirmedReducer,
  updateArrivalsReducer,
} from './needReducer';
import { receiptAddReducer, receiptDeleteReducer, receiptsListReducer } from './reportReducer';
import {
  contributionReducer,
  signatureReducer,
  signatureVerificationReducer,
  userSignaturesReducer,
  WalletInformationReducer,
  walletNonceReducer,
  walletVerifyReducer,
} from './blockchainReducer';
import {
  providerAddReducer,
  providerByIdReducer,
  providerByNeedReducer,
  providerDeleteReducer,
  providerListReducer,
  providerUpdateIsActiveReducer,
  providerUpdateReducer,
} from './providerReducer';
import {
  ticketListReducer,
  ticketAddReducer,
  ticketAddContentReducer,
  ticketByIdReducer,
  ticketUpdateReducer,
} from './ticketReducer';
import { milestoneReducer } from './milestoneReducer';
import {
  AnalyticChildNeedsReducer,
  analyticsContributionReducer,
  analyticsEcosystemReducer,
  analyticsFamilyReducer,
  analyticsNgosReducer,
} from './analyticReducer';
import { midjourneyReducer } from './midjourneyReducer';
import { commentsReducer } from './commentReducer';
import { campaignsReducer, newsLetterReducer } from './campaignReducer';
import crawlReducer from './crawlerReducer';

export default combineReducers({
  CustomizerReducer,
  ecoContribution: contributionReducer,
  familyAnalyitics: analyticsFamilyReducer,
  childNeedsAnalytics: AnalyticChildNeedsReducer,
  ngosAnalytics: analyticsNgosReducer,
  contributionAnalytics: analyticsContributionReducer,
  ecosystemAnalytics: analyticsEcosystemReducer,
  myTickets: ticketListReducer,
  ticketContentAdd: ticketAddContentReducer,
  ticketAdd: ticketAddReducer,
  ticketUpdate: ticketUpdateReducer,
  ticketById: ticketByIdReducer,
  walletNonce: walletNonceReducer,
  walletVerify: walletVerifyReducer,
  walletInformation: WalletInformationReducer,
  countryList: countryListReducer,
  myPage: myPageReducer,
  userLogin: userLoginReducer,
  userSearch: userSearchReducer,
  userBuilderStatus: userBuilderStatusReducer,
  user: userFetchReducer,
  userCheckPoints: userCheckPointsReducer,
  userChildrenList: userChildrenReducer,
  signature: signatureReducer,
  signaturesVerification: signatureVerificationReducer,
  signatures: userSignaturesReducer,
  changePassword: userChangePasswordReducer,
  swDetails: swDetailsReducer,
  swById: swByIdReducer,
  swStatusUpdate: swUpdateIsActiveReducer,
  swAll: swListReducer,
  swUpdate: swUpdateReducer,
  swAdd: swAddReducer,
  swMigrate: swMigrateReducer,
  swOneMigrate: swMigrateOneReducer,
  swNeedList: swNeedListReducer,
  swDelete: swDeleteReducer,
  childExampleNeeds: exampleNeedsReducer,
  childNeeds: childNeedsReducer,
  childOneNeed: childOneNeedReducer,
  childById: childByIdReducer,
  childAllActives: childActiveListReducer,
  childAll: childListReducer,
  childrenByNgo: childrenByNgoReducer,
  childUpdate: childUpdateReducer,
  childAdd: childAddReducer,
  childNeedsDuplicates: duplicatesReducer,
  childStatusUpdate: childUpdateStatusReducer,
  childNameCheck: childNameCheckReducer,
  oneChildPreRegister: oneChildPreRegisterReducer,
  childPreRegister: childPreRegisterReducer,
  childAllNames: childSayNameReducer,
  allNeeds: allNeedsReducer,
  allReportNeeds: allReportNeedsReducer,
  needPrepareConfirm: prepareConfirmReducer,
  needMassConfirm: massConfirmReducer,
  needConfirm: needConfirmReducer,
  needUnConfirmCount: unconfirmedReducer,
  needUpdate: needUpdateReducer,
  needStatusUpdate: needStatusUpdateReducer,
  needAdd: needAddReducer,
  ngoStatusUpdate: ngoUpdateIsActiveReducer,
  ngoById: ngoByIdReducer,
  ngoAll: ngoListReducer,
  ngoPreAll: ngoPreRegisterReducer,
  oneNgoPreRegister: oneNgoPreRegisterReducer,
  ngoPreRegister: ngoPreRegisterReducer,
  ngoArrivals: ngoArrivalReducer,
  ngoUpdate: ngoUpdateReducer,
  ngoAdd: ngoAddReducer,
  ngoDelete: ngoDeleteReducer,
  receiptList: receiptsListReducer,
  receiptDelete: receiptDeleteReducer,
  receiptAdd: receiptAddReducer,
  providerStatusUpdate: providerUpdateIsActiveReducer,
  providerById: providerByIdReducer,
  providerByNeed: providerByNeedReducer,
  providerAll: providerListReducer,
  providerUpdate: providerUpdateReducer,
  providerAdd: providerAddReducer,
  providerDelete: providerDeleteReducer,
  mileStone: milestoneReducer,
  midjourney: midjourneyReducer,
  deletedOld: deleteOldNeedsReducer,
  updateArrivals: updateArrivalsReducer,
  commentResult: commentsReducer,
  campaignResult: campaignsReducer,
  campaignNewsLetter: newsLetterReducer,
  crawls: crawlReducer,
});
